import HiveAccountCreatable from 'components/Dashboard/HiveAccountCreator/HiveAccountCreatable';
import { useRouter } from 'next/router';
import React from 'react';
import DashboardPage from '../../components/Dashboard/DashboardPage';
import withApollo from '../../lib/withApollo';

const ProfilePage = () => {
  const router = useRouter();

  const { open } = router.query;
  return (
    <DashboardPage
      open={open}
      label="create-hive-account"
      content={<HiveAccountCreatable />}
      shorttitle="Create a free Hive account"
    />
  );
};

export default withApollo(ProfilePage);
